import { FunctionComponent } from 'react';
import { Notifications } from '../../components/icons';
type TabsUIProps = {
  tabNames: string[],
  tabValue: number,
  variant?: "scrollable" | "fullWidth" | "standard",
  onChangeTabValue: Function,
  isMessageRead?: Array<Boolean>
  hideTabs?: number[]
}

// Main page/dialog tab bar. Copied verbatim from the (already Tailwind-only)
// MaterialUiComponents/Tabs wrapper so repointed call sites render identically.
const TabsUI: FunctionComponent<TabsUIProps> = ({
  tabNames,
  onChangeTabValue,
  variant = "standard",
  tabValue,
  isMessageRead,
  hideTabs = []
}) => {
  const handleChange = (index: number) => {
    if (!hideTabs.includes(index)) {
      onChangeTabValue(index);
    }
  };

  return (
    <div>
      <div className={"mb-1"}>
        <div
          role="tablist"
          className={[
            'ds-tabs',
            variant === 'scrollable' ? 'overflow-x-auto' : '',
            variant === 'fullWidth' ? 'w-full' : '',
          ].join(' ')}
        >
          {tabNames.map((name, index) => {
            const isHidden = hideTabs.includes(index);
            const isActive = tabValue === index;
            const hasUnread = isMessageRead !== undefined && isMessageRead[index] === false;

            return (
              <button
                key={index}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => handleChange(index)}
                // `.ds-tab` owns the active underline via `[aria-selected]`,
                // so the old hand-rolled `after:` indicator is gone.
                className={[
                  'ds-tab',
                  'flex items-center gap-1',
                  variant === 'fullWidth' ? 'flex-1 justify-center' : '',
                  isHidden ? 'hidden' : '',
                ].join(' ')}
              >
                {name}
                {hasUnread && (
                  <span className="flex items-center text-primary">
                    <Notifications fontSize="small" />
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default TabsUI;
